import React, { Component } from "react";
import {
  Card, CardBody, Table, Badge, Button, Input, Row, Col,
  Modal, ModalHeader, ModalBody,
} from "reactstrap";
import AiAdminLayout from "./layout";
import { fetchApi } from "./api";

class AiAdminConversations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      conversations: [],
      total: 0,
      page: 1,
      pages: 1,
      shopFilter: "",
      loading: true,
      // Detail modal
      detailModal: false,
      detail: null,
      detailLoading: false,
    };
  }

  async componentDidMount() {
    await this.loadConversations();
  }

  loadConversations = async () => {
    const { page, shopFilter } = this.state;
    this.setState({ loading: true });
    try {
      const params = `?page=${page}&limit=20${shopFilter ? `&shop_id=${shopFilter}` : ""}`;
      const data = await fetchApi(`/conversations${params}`);
      this.setState({
        conversations: data.conversations,
        total: data.total,
        pages: data.pages,
        loading: false,
      });
    } catch (err) {
      console.error("Conversations load error:", err);
      this.setState({ loading: false });
    }
  };

  handlePageChange = (newPage) => {
    this.setState({ page: newPage }, this.loadConversations);
  };

  viewDetail = async (conversationId) => {
    this.setState({ detailModal: true, detailLoading: true });
    try {
      const data = await fetchApi(`/conversations/${conversationId}`);
      this.setState({ detail: data, detailLoading: false });
    } catch (err) {
      console.error("Detail error:", err);
      this.setState({ detailLoading: false });
    }
  };

  render() {
    const {
      conversations, total, page, pages, shopFilter, loading,
      detailModal, detail, detailLoading,
    } = this.state;

    return (
      <AiAdminLayout>
        <h4 className="font-weight-bold mb-4">Conversations</h4>

        <Card style={{ borderRadius: 8 }}>
          <CardBody>
            <Row className="mb-3">
              <Col md={4}>
                <Input
                  type="number"
                  bsSize="sm"
                  placeholder="Filter by Shop ID..."
                  value={shopFilter}
                  onChange={(e) => this.setState({ shopFilter: e.target.value })}
                  onKeyDown={(e) => e.key === "Enter" && this.loadConversations()}
                />
              </Col>
              <Col md={2}>
                <Button size="sm" color="primary" onClick={this.loadConversations}>
                  Filter
                </Button>
              </Col>
              <Col md={6} className="text-right">
                <small className="text-muted">
                  Total: {total} | Page {page}/{pages}
                </small>
              </Col>
            </Row>

            {loading ? (
              <div className="text-center py-4">
                <div className="spinner-border spinner-border-sm text-primary" />
              </div>
            ) : conversations.length === 0 ? (
              <p className="text-muted text-center py-4">No conversations found</p>
            ) : (
              <>
                <Table responsive size="sm" style={{ fontSize: 13 }}>
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Shop</th>
                      <th>User</th>
                      <th>Status</th>
                      <th>Updated</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {conversations.map((c) => (
                      <tr key={c.id}>
                        <td style={{ maxWidth: 300 }}>
                          {c.title || "Untitled"}
                        </td>
                        <td>
                          <Badge color="light" className="text-dark">
                            #{c.tenant_id}
                          </Badge>
                        </td>
                        <td>{c.user_id}</td>
                        <td>
                          <Badge color={c.status === "active" ? "success" : "secondary"} pill>
                            {c.status}
                          </Badge>
                        </td>
                        <td style={{ fontSize: 11 }}>
                          {new Date(c.updatedAt).toLocaleString("vi-VN")}
                        </td>
                        <td>
                          <Button
                            color="link"
                            size="sm"
                            className="p-0"
                            onClick={() => this.viewDetail(c.id)}
                          >
                            View
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                {/* Pagination */}
                <div className="d-flex justify-content-center mt-3">
                  <Button
                    size="sm"
                    color="secondary"
                    disabled={page <= 1}
                    onClick={() => this.handlePageChange(page - 1)}
                    className="mr-2"
                  >
                    Previous
                  </Button>
                  <span className="align-self-center mx-2" style={{ fontSize: 13 }}>
                    {page} / {pages}
                  </span>
                  <Button
                    size="sm"
                    color="secondary"
                    disabled={page >= pages}
                    onClick={() => this.handlePageChange(page + 1)}
                  >
                    Next
                  </Button>
                </div>
              </>
            )}
          </CardBody>
        </Card>

        {/* Conversation Detail Modal */}
        <Modal isOpen={detailModal} toggle={() => this.setState({ detailModal: false })} size="lg">
          <ModalHeader toggle={() => this.setState({ detailModal: false })}>
            {detail?.conversation?.title || "Conversation Detail"}
          </ModalHeader>
          <ModalBody style={{ maxHeight: "70vh", overflow: "auto" }}>
            {detailLoading ? (
              <div className="text-center py-4">
                <div className="spinner-border spinner-border-sm text-primary" />
              </div>
            ) : detail?.messages ? (
              <div>
                {detail.messages.map((m) => (
                  <div
                    key={m.id}
                    className={`mb-3 d-flex ${m.role === "user" ? "justify-content-end" : "justify-content-start"}`}
                  >
                    <div
                      style={{
                        maxWidth: "80%",
                        padding: "8px 12px",
                        borderRadius: m.role === "user" ? "12px 12px 2px 12px" : "12px 12px 12px 2px",
                        backgroundColor: m.role === "user" ? "#667eea" : "#f0f0f0",
                        color: m.role === "user" ? "#fff" : "#333",
                        fontSize: 13,
                      }}
                    >
                      <div style={{ fontSize: 10, opacity: 0.7, marginBottom: 4 }}>
                        {m.role} {m.latency_ms ? `(${m.latency_ms}ms)` : ""}
                      </div>
                      <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                        {m.content_text || JSON.stringify(m.content_json, null, 2)}
                      </div>
                      <div style={{ fontSize: 10, opacity: 0.5, marginTop: 4 }}>
                        {new Date(m.createdAt).toLocaleString("vi-VN")}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-muted">No messages found</p>
            )}
          </ModalBody>
        </Modal>
      </AiAdminLayout>
    );
  }
}

export default AiAdminConversations;
